
import { Grid } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';
import { useUserContext } from '../../../../contexts/UserContext';
import DateField from '../../../../components/DateField';
import DefaultConstants from '../../../../data/Constants';
import Switch from '../../../../components/Switch';


interface IRoomBlockingFilterProps extends IDefaultDrawerProps {
    handleApplyFilters: (formData: FormData) => void;
}


const Filters: React.FC<IRoomBlockingFilterProps> = ({
    open,
    handleClose,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useUserContext();

    const [roomId, setRoomId] = useState<number>(0);
    const [startDate, setStartDate] = useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [typeId, setTypeId] = useState<number>(0);
    const [showRemoved, setShowRemoved] = useState<boolean>(false);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container columnSpacing={DefaultConstants.gridColumnSpacing}>
                <Grid item xs={12}>
                    <SelectField
                        label={translate('room')}
                        name='roomId'
                        value={roomId}
                        required={false}
                        onChange={e => setRoomId(e.target.value)}
                        data={[{ value: 0, text: translate('all') }].concat((enterprise?.partnerPms.rooms ?? []).map(r => {
                            return {
                                value: +r.id,
                                text: r.description
                            };
                        }))}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <DateField
                        label={translate('startDate')}
                        format='DD/MM/YYYY'
                        name='startDate'
                        value={startDate}
                        onChange={value => setStartDate(value)}
                        required={false}
                        disablePast={true}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <DateField
                        label={translate('endDate')}
                        format='DD/MM/YYYY'
                        name='endDate'
                        value={endDate}
                        onChange={value => setEndDate(value)}
                        required={false}
                        disablePast={true}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SelectField
                        label={translate('blockingType')}
                        name='typeId'
                        value={typeId}
                        required={false}
                        onChange={e => setTypeId(e.target.value)}
                        data={[{ value: 0, text: translate('all') }].concat((enterprise?.partnerPms.roomBlockingTypes ?? []).map(r => {
                            return {
                                value: +r.id,
                                text: r.description
                            };
                        }))}
                    />
                </Grid>

                <Grid item xs={12} marginTop={2} marginLeft={1}>
                    <Switch
                        label={translate('showRemoved')}
                        labelPlacement='end'
                        name='showRemoved'
                        value={showRemoved ? 1 : 0}
                        checked={showRemoved}
                        onChange={e => setShowRemoved(e.target.checked)}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;